
var waitFor = require('../utils/waitFor');

waitFor('.location-dropdown-details', function() {

	var jsCookies = require('js-cookie');

  var $dropdownToggle = $('[data-js-location-dropdown-toggle]');
  var $dropdownList = $('[data-js-location-dropdown-list]');

  // toggle location list
  $dropdownToggle.on('click', toggleLocMenu);

  $dropdownList.on('click', '.location-dropdown-details__entry', function(e){
  	var $loc = $(e.currentTarget);

  	$dropdownToggle.html($loc.clone());

  	jsCookies.set('intranet-location', $loc.attr('data-slug'));

  	//close the menu
  	toggleLocMenu();
  });

  // init times
  var lastMinute = -1;
	function updateTimes(){
		var now = new Date(),
			utc = now.getTime() + (now.getTimezoneOffset() * 60000);
	  
	  setTimeout(updateTimes, 5000);

		if(now.getMinutes() <= lastMinute)
			return;

	  $('.location-dropdown-details__entry').each(function(i, el){
	  	var $el = $(el),
	  		$timeEl = $el.find('.location-dropdown-details__entry-time'),
	  		offset = $timeEl.attr('data-utc-offset') * 1000,
		    tzTime = new Date(utc + offset);

	  		$timeEl.text( tzTime.getHours() + ':' + leftPad(tzTime.getMinutes()) );
	  });

		lastMinute = now.getMinutes();
	}

  function leftPad(n){
    return ("00" + n).slice(-2);
  }

  function toggleLocMenu(){
    $dropdownToggle.toggleClass('location-dropdown-details__toggle--active');
    $dropdownList.slideToggle( "200" );
  }

  // set default time
  var $default = $('.location-dropdown-details__entry.default-time'),
  	savedLoc = jsCookies.get('intranet-location');

  if(savedLoc && savedLoc.length > 0)
  	$dropdownToggle.html( $('.' + savedLoc).clone() );
  else if($default.length > 0)
	  $dropdownToggle.html( $default.clone() );

  updateTimes();

});
